import apiTransaction from '@/api/member/transaction';

const defaultState = () => ({
	dataDownlineData: [],
	dataDownlinePagination: '',
	historyCoinGenData: [],
	historyCoinGenPagination: '',
	transactionData: [],
	transactionPagination: '',
	loadTransaction: false,
	detailTransaction: {},
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setDataDownline(state, data) {
		state.dataDownlineData = data.data
		state.dataDownlinePagination = data.pagination;
	},
	setHistoryCoinGen(state, data) {
		state.historyCoinGenData = data.data
		state.historyCoinGenPagination = data.pagination;
	},
	setTransaction(state, data) {
		state.transactionData = data.data
		state.transactionPagination = data.pagination;
	},
	setloadTransaction(state, data) {
		state.loadTransaction = data
	},
	setTransactionDetail(state, data) {
		state.detailTransaction = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearTransaction(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	dataDownline({ commit }, params) {
		commit('setloadTransaction', true);
		return new Promise((resolve) => {
			apiTransaction.dataDownline(params).then(({ data: { data } }) => {
				commit('setDataDownline', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setDataDownline', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadTransaction', false);
			});
		});
	},
	historyCoinGen({ commit }, params) {
		commit('setloadTransaction', true);
		return new Promise((resolve) => {
			apiTransaction.historyCoinGen(params).then(({ data: { data } }) => {
				commit('setHistoryCoinGen', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setHistoryCoinGen', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadTransaction', false);
			});
		});
	},
	getTransaction({ commit }, params) {
		commit('setloadTransaction', true);
		return new Promise((resolve) => {
			apiTransaction.getTransaction(params).then(({ data: { data } }) => {
				commit('setTransaction', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setTransaction', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadTransaction', false);
			});
		});
	},
	async getTransactionDetail({ commit, dispatch }, params) {
		await commit('setloadTransaction', true);
		return new Promise((resolve, reject) => {
			apiTransaction.getTransactionDetail(params).then(({ data: { data } }) => {
				commit('setTransactionDetail', data.results);
				resolve(data.results);
			}).catch((err) => {
				const { data } = err.response;
				commit('setTransactionDetail', {});
				reject(data.message)
				dispatch('errorHandler', data);
			}).then(() => {
				commit('setloadTransaction', false);
			});
		});
	},
	cancelTransaction({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaction.cancelTransaction(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Transaksi berhasil dibatalkan', show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	cancelBank({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaction.cancelBank(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Transaksi berhasil dibatalkan', show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	cancelStore({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaction.cancelStore(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Transaksi berhasil dibatalkan', show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	cancelVA({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaction.cancelVA(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Transaksi berhasil dibatalkan', show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	async receiveTransaction({ commit, dispatch }, params) {
		await commit('setloadTransaction', true);
		return new Promise((resolve, reject) => {
			apiTransaction.receiveTransaction(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Proses penerimaan berhasil', show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			}).then(() => {
				commit('setloadTransaction', false);
			});
		});
	},
	async uploadConfirmation({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiTransaction.uploadConfirmation(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Konfirmasi Transfer berhasil diproses', show: true }, { root: true });
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	success({ commit }, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};